import React from 'react';
import PropTypes from 'prop-types';

export const QuizNavigation = ({
  isAnswerChecked,
  hasAnswer,
  isLastQuestion,
  onCheckAnswer,
  onNext,
  onFinish
}) => {
  // Log props for debugging
  console.log('QuizNavigation Props:', {
    isAnswerChecked,
    hasAnswer,
    isLastQuestion
  });

  return (
    <div className="navigation-buttons">
      {/* Check Answer Button */}
      <button 
        className={`check-answer-button ${isAnswerChecked ? 'checked' : ''} ${!hasAnswer ? 'disabled' : ''}`}
        onClick={onCheckAnswer}
        disabled={!hasAnswer || isAnswerChecked}
        aria-disabled={!hasAnswer || isAnswerChecked}
      >
        {isAnswerChecked ? 'Answer Checked' : 'Check Answer'}
      </button>
      
      {/* Next/Finish Button */}
      <button 
        className={`next-button ${!isAnswerChecked ? 'disabled' : ''}`}
        onClick={isLastQuestion ? onFinish : onNext}
        disabled={!isAnswerChecked}
        aria-disabled={!isAnswerChecked}
      >
        {isLastQuestion ? 'Finish' : 'Next'}
      </button>
    </div>
  );
};

QuizNavigation.propTypes = {
  isAnswerChecked: PropTypes.bool.isRequired,
  hasAnswer: PropTypes.bool.isRequired,
  isLastQuestion: PropTypes.bool.isRequired,
  onCheckAnswer: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired
};

// No default props needed as all props are required
